<div
    class="h-screen overflow-hidden bg-white md:grid md:h-(--full-height-without-navigation) md:grid-cols-5">
    <app-dashboard-sidebar></app-dashboard-sidebar>
    <main
        class="col-span-4 h-full overflow-y-auto p-4 pb-20 md:min-h-0 md:pt-4">
        <ng-content></ng-content>
    </main>
</div>
